import type { MissionBulkWorker } from '@/modules/companyNeed/types/missions';
import type {
	PoolWorkersQueryParams,
	WorkerPool,
} from '@/modules/companyNeed/views/details/pool/types';
import type { WorkerListItem } from '@/modules/worker/types';

export enum AddWorkerTabId {
	POOL = 'pool',
	ONGOING_PROPOSAL = 'ongoing-proposal',
	ALL_PROFILES = 'all-profiles',
}

export const ALL_PROFILES_MIN_SEARCH_LENGTH = 3;

export const ALL_PROFILES_SEARCH_LIMIT = 25;

export const ADD_WORKER_SEARCH_DEBOUNCE_MS = 400;

export interface AddWorkerToMissionModalProps {
	open: boolean;
	missionId: string;
	besoinId: string;
	missionTitle: string;
	excludedWorkerIds: string[];
	onWorkerAdded?: (
		worker: MissionBulkWorker,
		options?: { bumpMissionsListQuantity: boolean }
	) => void;
	onAllAdditionsDone?: () => void;
}

export interface BuildWorkersQueryParamsInput {
	missionId: string;
	search: string;
	offset?: number;
	limit?: number;
}

export interface CanFetchWorkersInput {
	besoinId: string;
	activeTabId: AddWorkerTabId;
	searchLength: number;
}

export interface FetchWorkersForTabInput {
	besoinId: string;
	activeTabId: AddWorkerTabId;
	queryParams: PoolWorkersQueryParams;
	search: string;
}

export interface ResolveAddWorkerListStateTextInput {
	isAllProfilesSearchPromptVisible: boolean;
	isLoading: boolean;
	isServiceUnavailable: boolean;
	loadError: boolean;
	isListEmpty: boolean;
	isFilterEmpty: boolean;
	activeTabId: AddWorkerTabId;
	t: (key: string) => string;
}

export interface ApplyBulkAddItemResultCallbacks {
	onSuccess: () => void;
	onAlreadyAssigned: () => void;
	onMaxWorkersReached: () => void;
	onRegistrationNotComplete: () => void;
	onError: () => void;
}

export interface HandleAddWorkerMissionErrorCallbacks {
	onMaxWorkersReached: () => void;
	onError: () => void;
}

export interface AddWorkerTabCounts {
	[AddWorkerTabId.POOL]?: number;
	[AddWorkerTabId.ONGOING_PROPOSAL]?: number;
}

export interface AddWorkerTabListSnapshot {
	items: WorkerPool[];
	total: number;
	nextOffset: number;
	hasNextPage: boolean;
}

export interface BuildAddWorkerTabSnapshotInput {
	items: WorkerPool[];
	total: number;
	pageLimit: number;
	excludedWorkerIds: readonly string[];
}

export interface BuildAddWorkerTabsConfigInput {
	activeTabId: AddWorkerTabId;
	t: (key: string) => string;
	tabCounts?: AddWorkerTabCounts;
}

export interface WorkerListItemWithAgencies extends WorkerListItem {
	agencies?: string[];
	agenciesList?: string[];
}

export interface FormatWorkerAgenciesLabelInput {
	agencies?: WorkerPool['agencies'];
	agencyName?: string | null;
	currentAgencyId?: string | null;
	t: (key: string, values?: Record<string, unknown>) => string;
}
